module.exports = "/dist/images/pdf-white.png?43dcab361b4556823725171e557e10cf";